import React, { useEffect, useState } from 'react';
import isEmpty from "lodash/isEmpty";
import appColors from "../../const/colors";
import { Input, Row } from 'antd';
import { FormItem } from "formik-antd";
import { EMPTY_VALUE_PLACEHOLDER } from "../../const/system";



export const isValidHex = (value) => {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value);
};

const ColorPicker = ({
  name = '',
  defaultValue = appColors.white,
  onChange = () => {},
  disabled = false,
  error = null,
  isView = false,
 }) => {
  const [ color, setColor ] = useState(defaultValue);
  const [ inputValue, setInputValue ] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue !== undefined) {
      const newValue = !isEmpty(defaultValue) ? defaultValue : null;
      setColor(newValue);
      setInputValue(newValue);
    }
  }, [ defaultValue ]);

  const handleColorChange = (event) => {
    const newColor = event.target.value.toUpperCase();
    setColor(newColor);
    setInputValue(newColor);
    onChange(newColor);
  };


  return (
      <Row className={isView ? 'flex-center' : ''}>
        <Input
          name={name}
          disabled={disabled}
          type="color"
          className="color-picker__input"
          id={name}
          value={color}
          onChange={handleColorChange}
        />
        <label
          htmlFor={name}
          className={`color-picker__display ${!disabled ? 'color-picker__display_pointer' : ''}`}
          style={{ backgroundColor: color, width: "32px" }}
        />

        {isView ? (
          <span className='color-picker__text'>
            {!isEmpty(color) ? color.toUpperCase() : EMPTY_VALUE_PLACEHOLDER}
          </span>
        ) : (
          <FormItem
            name='input-hex-value'
            validateStatus={error ? "error" : ""}
            help={error}
            className='hp-ml-8 hp-mb-0'
          >
            <Input
              size='small'
              placeholder="HEX value"
              style={{ width: 100, minHeight: "unset" }}
              name={name}
              value={inputValue || null}
              onChange={handleColorChange}
              disabled={disabled}
            />
          </FormItem>
        )}
      </Row>
  );
};


export default ColorPicker;
